<template>
 <div class="content-middle">
   <div class="cont-con clearfix">
            <div class="cont-left  hidden-xs">
                <div class="contl-header">
                    蓝牙高频小精灵
                    <button class="menu-button" id="open-button">Open Menu</button>
                </div>
                <div class="menu-wrap">
                    <nav class="menu">
                        <div class="icon-list">
                            <router-link  :to="{path: list.url, query: {index: index}}"  :class="{'current': currentIndex == index}" v-for="(list, index) in lists" v-bind:key="index">{{list.text}}</router-link>
                        </div>
                    </nav>
                    <button class="close-button" id="close-button">Close Menu</button>
                </div>
            </div>
            <div class="cont-right">
                  <div class="contr-header clearfix">
                  <h4>{{bhname}}</h4>
                    <div class="contr-nav">
                        <router-link to="/" >首页</router-link> &gt;
                        <router-link :to="{path:'/BH',query: {index: 0}}">蓝牙高频小精灵</router-link> &gt; {{bhname}}
                    </div>
                    </div>
                <router-view></router-view>
            </div>
        </div>
 </div>
</template>

<script>
 export default {
   mounted() {
     this.bhname = this.$route.meta.title;
    this.currentIndex = this.$route.query.index;
  },
   data () {
     return {
        bhname:'BH04',
       currentIndex: 0,
       lists: [{text:'BH04',url:'/BH/04'},{text: 'BH04KB',url: '/BH/04KB'}]
     }
   },
   methods: {
   },
   watch: {
     $route(to, from) {
       if(to!= undefined) {
         this.currentIndex = to.query.index
          this.bhname = to.meta.title
       }
     }
   },
   components: {

   }
 }
</script>

<style lang="stylus" scoped rel="stylesheet/stylus">

 
</style>



// WEBPACK FOOTER //
// src/components/BH/BHindex.vue